import { PropsWithChildren, StrictMode, useEffect } from 'react';

import { AppInsightsProvider } from '@xemplo/app-insights';
import { useGlobalFont } from '@xemplo/global-font';
import { initSentry } from '@xemplo/xemplo-sentry';

import { CrossAppDataHandover } from './data-handover/data-handover';
import { useRootStyle } from './hooks/use-root-style';
import { AppBoostrapProps } from './app-bootstrap.types';
import { useAmplitudeInit } from './hooks';

export function AppBootstrap({
  children,
  settings,
  sentryConfig,
}: PropsWithChildren<AppBoostrapProps>) {
  useAmplitudeInit(settings);
  useGlobalFont();
  useRootStyle('light');

  useEffect(() => {
    initSentry({
      ...sentryConfig,
      dsn: settings.VITE_SENTRY_DSN,
      environment: settings.VITE_RELEASE_CHANNEL,
    });

    // To be on safe side, adding as mount effect to avoid
    // re-initialization of Sentry on every render, though
    // this is not expected to happen as AppBootstrap is
    // intended to be used as a root component.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <StrictMode>
      <AppInsightsProvider
        instrumentationKey={settings.VITE_INSTRUMENTATION_KEY}
        cloudRole={settings.VITE_CLOUD_ROLE}
        appName={settings.VITE_APP_NAME}
      >
        <CrossAppDataHandover settings={settings}>{children}</CrossAppDataHandover>
      </AppInsightsProvider>
    </StrictMode>
  );
}
